/* eslint-disable @next/next/no-img-element */
"use client";
import Image from "next/image";

const Img = ({
  imgScale = 1,
  avgLineHeight = 1,
  inAbstract = false,
  fragment: { id, alt = "image", width = 1, height = 1, src, inline }
}) => (
  <Image
    id={id}
    alt={alt}
    src={src}
    priority={inAbstract}
    width={width}
    height={height}
    onLoad={event => {
      try {
        const img = event?.target ?? event.currentTarget ?? event;
        const currentFontSize = Number(
          getComputedStyle(img.parentNode.closest("p")).lineHeight.slice(0, -2)
        );
        const scaledLineHeight = avgLineHeight * imgScale;
        const scalingFactor = currentFontSize / scaledLineHeight;
        const adjustedWidth = (width ?? img.naturalWidth) * scalingFactor; //* 1.1;

        if (inline) {
          const adjustedHeight =
            ((height ?? img.naturalHeight) * scalingFactor) / 1.1;

          img.style.height = `${adjustedHeight}px`;
        } else {
          img.style.width = `${adjustedWidth}px`;
        }

        // img.style.removeProperty("display");
      } catch (error) {
        console.error(error);
      } finally {
        console.log("done");
      }
    }}
    style={{
      aspectRatio: `${width} / ${height}`,
      // display: "none",
      filter: "var(--paperImg)",
      ...(inline
        ? { width: "auto" }
        : {
            maxWidth: "90%",
            margin: "auto",
            height: "auto",
            display: "block"
          })
    }}
  />
);

export default Img;
